module.exports = __webpack_public_path__ + "img/about-volleyball-panda.2ce9c45e.png";